/**
 * Presentation helpers for "onde a LLM rodou" (card #76).
 *
 * The backend records, per job, how many local generation calls ran on the
 * desktop's Ollama vs the prism-server's own, plus the host of the most
 * recent call (`current`) — what "onde está rodando agora" reads for a job
 * still in flight. See `JobLlmHosts` in the backend jobs schema.
 */
import type { Job } from '@/api/endpoints/jobs'

export type LlmHost = 'desktop' | 'server'
export type JobLlmHosts = NonNullable<Job['llm_hosts']>

/** Short PT-BR label for a host — desktop's GPU vs the prism-server's own. */
export function llmHostLabel(host: LlmHost): string {
  return host === 'desktop' ? 'Desktop' : 'Servidor'
}

/** True when the job made at least one local (Ollama) call worth showing. */
export function hasLocalLlm(hosts: JobLlmHosts | null | undefined): boolean {
  if (!hosts) return false
  return (hosts.desktop || 0) > 0 || (hosts.server || 0) > 0
}

/**
 * One-line summary of local-LLM host usage, e.g. "Desktop 12 · Servidor 3".
 * Returns null when the job made no local calls (cloud-only / no telemetry).
 */
export function llmHostsSummary(hosts: JobLlmHosts | null | undefined): string | null {
  if (!hosts) return null
  const desktop = hosts.desktop || 0
  const server = hosts.server || 0
  const parts: string[] = []
  if (desktop > 0) parts.push(`Desktop ${desktop.toString()}`)
  if (server > 0) parts.push(`Servidor ${server.toString()}`)
  return parts.length > 0 ? parts.join(' · ') : null
}
